import * as React from "react";
import Svg, { Path } from "react-native-svg";

type Props = React.ComponentProps<typeof Svg>;

export default function LogoMark(props: Props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={37}
      height={37}
      viewBox="0 0 37 37"
      fill="none"
      {...props}
    >
      <Path
        fill="#006FB9"
        d="M13.322 20.95c.247 0 .476.133.6.347l4.21 7.312a.695.695 0 0 1 0 .693l-1.956 3.396a4.43 4.43 0 0 1-3.182-1.37c-.317-.333-.829-.45-1.214-.199-.384.25-.496.77-.197 1.116a6.105 6.105 0 0 0 3.675 2.047l-1.336 2.322a.692.692 0 0 1-.6.346h-8.42a.692.692 0 0 1-.6-.346l-4.21-7.312a.695.695 0 0 1 0-.693l4.21-7.312a.692.692 0 0 1 .6-.346h8.42Z"
      />
      <Path
        fill="#EC008D"
        d="M32.968 20.911a4 4 0 0 1 4 4v7.71a4.432 4.432 0 0 1-4.04-1.294c-.318-.332-.83-.449-1.214-.198-.384.25-.497.769-.198 1.116a6.091 6.091 0 0 0 5.222 2.09A4 4 0 0 1 32.968 37H24.92a4 4 0 0 1-4-4v-8.089a4 4 0 0 1 4-4h8.047Z"
      />
      <Path
        fill="#00A881"
        d="M9.113 0c4.986 0 9.029 4.053 9.029 9.053 0 1.339-.293 2.609-.814 3.753a4.431 4.431 0 0 1-4.334-1.226c-.317-.332-.828-.448-1.213-.197-.384.25-.497.769-.198 1.116a6.104 6.104 0 0 0 4.647 2.12 9.002 9.002 0 0 1-7.117 3.486c-4.987 0-9.03-4.053-9.03-9.052 0-5 4.043-9.053 9.03-9.053Z"
      />
      <Path
        fill="#F7941D"
        d="M28.944 0c-4.986 0-9.029 4.053-9.029 9.053 0 1.339.293 2.609.814 3.753a4.431 4.431 0 0 0 4.334-1.226c.317-.332.828-.448 1.213-.197.384.25.497.769.198 1.116a6.104 6.104 0 0 1-4.647 2.12 9.002 9.002 0 0 0 7.117 3.486c4.987 0 9.03-4.053 9.03-9.052 0-5-4.043-9.053-9.03-9.053Z"
      />
    </Svg>
  );
}
